import axiosClient from '../../configs/axios';


class RmMasterService {
    // Get list 
    async getRMList(params) {
        try {
            const response = await axiosClient.get(
                `/rm/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addRM(data) {
        try {
            const response = await axiosClient.post('/rm/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteRM(data) {
        try {
            const response = await axiosClient.put(`/rm/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new RmMasterService(); 